
// import { useFormPreventaCorporativaInstalacion, useFormPreventaCorporativaServicio } from "@/erp/sale/asesor/preventa/shared/hook/useFormPreventaCorporativa";
import {
  EntidadFinancieraENUM,
  fnMostrarTipoTarjeta,
  gridSizeMdLg12,
  gridSizeMdLg6,
  texto,
  TIPO_CUENTA_BANCARIA_CHOICE,
  TipoCuentaBancariaEnumChoice,
} from "@/shared";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomTextFieldNumberComponente,
  SampleDatePicker,
  TabTextLabel,
} from "@/shared/components/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import {
  Cooperativa,
  EntidadesFinancieras,
  IPaymentMethod,
  PaymentMethodEnum,
  TipoPlanCorporativo,
  // PlanesCorporativos,
} from "@/shared/interfaces";
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { CondicionVentaCorporativa } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import { usePaymentMethodsStore } from "@/store/erp/system-settings/payment-methods";
// import { usePlanStore } from "@/store/erp/system-settings/plan.store";
// import { useTypeInstalation } from "@/store/erp/system-settings/type-instalation";
import { Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";

interface TabPlanesPagosProps {
  form: UseFormReturn<IPreventaCorporativoForm2, any, IPreventaCorporativoForm2>;



  formFormasPagosServicio:any;
  handleFormaPagoServicio:any;
  dataCooperativaServicio:any;
  isLoadingCooperativaServicio:any;
  tipoTarjetaServicio:any;
  isLoadingEntidadFinancieroServicio:any;
  dataEntidadFinancieroServicio:any;

  formFormasPagosInstalacion:any;
  handleFormaPagoInstalacion:any;
  dataCooperativaInstalacion:any;
  isLoadingCooperativaInstalacion:any;
  tipoTarjetaInstalacion:any;
  isLoadingEntidadFinancieroInstalacion:any;
  dataEntidadFinancieroInstalacion:any;
  enableEdit?: boolean;
  // disabledAll?: boolean;
}
export default function TabPlanesPagos({
  form: formPlanesPagos,

  formFormasPagosServicio,
  handleFormaPagoServicio,
  dataCooperativaServicio,
  isLoadingCooperativaServicio,
  tipoTarjetaServicio,
  isLoadingEntidadFinancieroServicio,
  dataEntidadFinancieroServicio,

  formFormasPagosInstalacion,
  handleFormaPagoInstalacion,
  dataCooperativaInstalacion,
  isLoadingCooperativaInstalacion,
  tipoTarjetaInstalacion,
  isLoadingEntidadFinancieroInstalacion,
  dataEntidadFinancieroInstalacion,

  // enableEdit=false,

}: // disabledAll=false
  TabPlanesPagosProps) {

    const [paymentMethods, setPaymentMethods] = useState<IPaymentMethod[]>([]);
  

  const {
    // control,
    reset,
    // formState: { errors },
  } = formPlanesPagos;

  const paymentMethodsFilterPaging = usePaymentMethodsStore(
    (s) => s.paymentMethodsFilterPaging
  );

  useEffect(()=>{
    const corporatePlansFiltered = paymentMethodsFilterPaging?.filter((x)=>x.nombre.includes("DÉBITO") || x.nombre.includes("TRANSFERENCIA") || x.nombre.includes("CONTRAFACTURA") || x.nombre.includes("OTRO")) || []
    setPaymentMethods(corporatePlansFiltered)
    
  },[paymentMethodsFilterPaging])

  // const watcherTipoPlan = formPlanesPagos.watch().tipo_plan

  // const valorInstalacion = formPlanesPagos.watch().valor_instalacion




  // const typInstalation = useTypeInstalation((s) => s.typInstalation);
  // const isLoadingTypeInstalation = useTypeInstalation(
  //   (s) => s.isLoadingTypeInstalation
  // );


  // const isLoadingPaymentMethodsPaging = usePaymentMethodsStore((s) => s.isLoadingPaymentMethodsPaging)
  // const plans = usePlanStore((s) => s.plans);
  // const isLoadingPlans = usePlanStore((s) => s.isLoadingPlans);

  

  return (
    <Grid container {...gridSizeMdLg12} spacing={3} marginY={0}>
      {/* 
      // =======================================================================
      // Validación para que en caso de canje o evento gratuito no se muestre data de forma de pago
      // ======================================================================= */}
      {!(formPlanesPagos?.getValues()?.condicion_venta==CondicionVentaCorporativa.CANJE 
        || formPlanesPagos?.getValues()?.condicion_venta==CondicionVentaCorporativa.EVENTO_GRATUITO
        || formPlanesPagos?.getValues()?.tipo_plan==TipoPlanCorporativo.EVENTO_GRATUITO
        || formPlanesPagos?.getValues()?.tipo_plan==TipoPlanCorporativo.CANJE
      ) ?
      // && formPlanesPagos?.getValues()?.condicion_venta==CondicionVentaCorporativa.EVENTO_PAGADO?
      <Grid item container {...gridSizeMdLg12} spacing={3}>
        {/* <Grid item {...gridSizeMdLg12} display={"flex"}>
          <Typography variant="h6">Formas de Pago</Typography>
        </Grid> */}


        {/* ------------- Forma Pago Servicio */}
        <Grid item {...gridSizeMdLg12}>
          <TabTextLabel text={"Forma Pago Servicio"} mt={0} pb={0} pl={0} pt={0} />
        </Grid>
        <CustomAutocomplete<IPaymentMethod>
          required={true}
          size={gridSizeMdLg12}
          label={texto.forma_pago}
          name="forma_pago"
          // options
          options={paymentMethods || []}
          valueKey="alias"
          actualValueKey="codigo"
          defaultValue={formFormasPagosServicio.getValues().forma_pago || formPlanesPagos.getValues().metodo_pago_mensualidad || ""}
          isLoadingData={false}
          // validation
          control={formFormasPagosServicio.control}
          error={formFormasPagosServicio?.formState.errors.forma_pago}
          helperText={formFormasPagosServicio?.formState.errors.forma_pago?.message}
          onChangeRawValue={(e) => {
            console.log(e)
            reset({
              ...formPlanesPagos.getValues(),
              metodo_pago_mensualidad: e.codigo
            })
            handleFormaPagoServicio(e)
          }}
        />

        {/* {!isPendingValorInstalacion && ( */}
        <>
          {/* <CustomTextField
            size={gridSizeMdLg6}
            disabled={true}
            name="tipo_contrato"
            label={texto.tipo_contrato}
            control={formFormasPagosServicio.control}
            defaultValue={
              formFormasPagosServicio.getValues().tipo_contrato || ""
            }
            error={formFormasPagosServicio?.formState.errors.tipo_contrato}
            helperText={formFormasPagosServicio?.formState.errors.tipo_contrato?.message}
            onChangeValue={(e) => {
              reset({ ...formPlanesPagos.getValues(), tipo_contrato: e });
            }}
          /> */}

          {formFormasPagosServicio.getValues().codigo_forma_pago == PaymentMethodEnum.DEBITO
            && (
              <>
                <CustomAutocompleteArrString
                  size={gridSizeMdLg6}
                  label={texto.tipo_cuenta}
                  name="tipo_cuenta_bancaria"
                  options={
                    formFormasPagosServicio.getValues().entidad_financiera ==
                      EntidadFinancieraENUM.GUAYAQUIL
                      ? TIPO_CUENTA_BANCARIA_CHOICE
                      : TIPO_CUENTA_BANCARIA_CHOICE.filter(
                        (e) => e != TipoCuentaBancariaEnumChoice.AMIGA
                      ) || []
                  }
                  defaultValue={
                    formFormasPagosServicio.getValues().tipo_cuenta_bancaria
                    || formPlanesPagos.getValues().tipo_cuenta
                  }
                  isLoadingData={false}
                  control={formFormasPagosServicio.control}
                  error={formFormasPagosServicio?.formState.errors.tipo_cuenta_bancaria}
                  helperText={formFormasPagosServicio?.formState.errors.tipo_cuenta_bancaria?.message}
                  onChangeValue={(e) => {
                    reset({
                      ...formPlanesPagos.getValues(),
                      tipo_cuenta: e,
                    });
                  }}
                />

                {!isLoadingCooperativaServicio &&
                  dataCooperativaServicio?.length != 0 && (
                    <CustomAutocomplete<Cooperativa>
                      size={gridSizeMdLg6}
                      label={texto.cooperativa}
                      name="cooperativa"
                      // options
                      options={dataCooperativaServicio || []}
                      valueKey="nombre" // name is the fk
                      actualValueKey="codigo"
                      defaultValue={
                        formFormasPagosServicio.getValues().cooperativa || ""
                      }
                      isLoadingData={isLoadingCooperativaServicio}
                      // validation
                      control={formFormasPagosServicio?.control}
                      error={formFormasPagosServicio?.formState.errors.cooperativa}
                      helperText={formFormasPagosServicio?.formState.errors.cooperativa?.message}
                      onChangeValue={(e) => {
                        reset({ ...formPlanesPagos.getValues(), cooperativa: e });
                      }}
                    />
                  )}

                <CustomTextFieldNumberComponente
                  type={TiposTextFieldNumberEnum.TARJETA}
                  size={gridSizeMdLg12}
                  label={texto.numero_cuenta}
                  error={formFormasPagosServicio?.formState.errors.numero_cuenta}
                  helperText={formFormasPagosServicio?.formState.errors.numero_cuenta?.message}
                  control={formFormasPagosServicio.control}
                  name="numero_cuenta"
                  defaultValue={formFormasPagosServicio.getValues().numero_cuenta}
                  max={25}
                  onChangeValue={(e) => {
                    reset({ ...formPlanesPagos.getValues(), numero_cuenta: e });
                  }}
                />
              </>
            )}

          {formFormasPagosServicio.getValues().codigo_forma_pago ==
            PaymentMethodEnum.TARJETA && (
              <>
                <CustomAutocomplete<EntidadesFinancieras>
                  size={gridSizeMdLg6}
                  label={texto.entidad_finciera}
                  name="entidad_financiera"
                  // options
                  options={dataEntidadFinancieroServicio?.data.data || []}
                  valueKey="nombre" // name is the fk
                  actualValueKey="codigo"
                  defaultValue={
                    formFormasPagosServicio.getValues().entidad_financiera || ""
                  }
                  isLoadingData={isLoadingEntidadFinancieroServicio}
                  // validation
                  control={formFormasPagosServicio.control}
                  error={formFormasPagosServicio?.formState.errors.entidad_financiera}
                  helperText={formFormasPagosServicio?.formState.errors.entidad_financiera?.message}
                  onChangeValue={(e) => {
                    reset({
                      ...formPlanesPagos.getValues(),
                      entidad_bancaria: e,
                    });
                  }}
                />

                <SampleDatePicker
                  format="YYYY-MM"
                  views={["year", "month"]}
                  label="Fecha Caducidad"
                  name="tarjeta_fecha_caducidad"
                  minDate={dayjs(new Date())}
                  control={formFormasPagosServicio.control}
                  defaultValue={
                    formFormasPagosServicio.getValues().tarjeta_fecha_caducidad ??
                    ""
                  }
                  error={formFormasPagosServicio?.formState.errors.tarjeta_fecha_caducidad}
                  helperText={formFormasPagosServicio?.formState.errors.tarjeta_fecha_caducidad?.message}
                  size={gridSizeMdLg6}
                  onChangeValue={(e) => {
                    reset({
                      ...formPlanesPagos.getValues(),
                      fecha_caducidad_tarjeta: e,
                    });
                  }}
                />

                <CustomTextFieldNumberComponente
                  type={TiposTextFieldNumberEnum.TARJETA}
                  startAdornment={
                    fnMostrarTipoTarjeta(tipoTarjetaServicio) ? (
                      <img
                        src={fnMostrarTipoTarjeta(tipoTarjetaServicio)}
                        alt="imge-tarjeta"
                        width={"50px"}
                      />
                    ) : null
                  }
                  size={gridSizeMdLg12}
                  label={texto.ingresar_num_tarjeta}
                  error={formFormasPagosServicio?.formState.errors.numero_tarjeta}
                  helperText={formFormasPagosServicio?.formState.errors.numero_tarjeta?.message}
                  control={formFormasPagosServicio.control}
                  name="numero_tarjeta"
                  defaultValue={
                    formFormasPagosServicio.getValues().numero_tarjeta ?? ""
                  }
                  max={24}
                  onChangeValue={(e) => {
                    reset({ ...formPlanesPagos.getValues(), numero_tarjeta: e });
                  }}
                />
              </>
            )}

        </>







        {/*--------------------- FORMA PAGO INSTALACION */}
        <Grid item {...gridSizeMdLg12}>
          <TabTextLabel text={"Forma Pago Instalacion"} mt={0} pb={0} pl={0} pt={0} />
        </Grid>
        <CustomAutocomplete<IPaymentMethod>
          required={true}
          size={gridSizeMdLg12}
          label={texto.forma_pago}
          name="forma_pago"
          // options
          options={paymentMethods || []}
          valueKey="alias"
          actualValueKey="codigo"
          defaultValue={formFormasPagosInstalacion.getValues().forma_pago || formPlanesPagos.getValues().metodo_pago_instalacion || ""}
          isLoadingData={false}
          // validation
          control={formFormasPagosInstalacion.control}
          error={formFormasPagosInstalacion.formState.errors.forma_pago}
          helperText={formFormasPagosInstalacion.formState.errors.forma_pago?.message}
          // onChangeRawValue={(e) => handleFormaPagoInstalacion(e)}
          onChangeRawValue={(e) => {
            reset({
              ...formPlanesPagos.getValues(),
              metodo_pago_instalacion: e.codigo
            })
            handleFormaPagoInstalacion(e)
          }}
        />

        {/* {!isPendingValorInstalacion && ( */}
        <>
          {/* <CustomTextField
            size={gridSizeMdLg6}
            disabled={true}
            name="tipo_contrato"
            label={texto.tipo_contrato}
            control={formFormasPagosInstalacion.control}
            defaultValue={
              formFormasPagosInstalacion.getValues().tipo_contrato || ""
            }
            error={formFormasPagosInstalacion?.formState.errors.tipo_contrato}
            helperText={formFormasPagosInstalacion?.formState.errors.tipo_contrato?.message}
            onChangeValue={(e) => {
              reset({ ...formPlanesPagos.getValues(), tipo_contrato_instalacion: e });
            }}
          /> */}
          {/* <CustomTextFieldNoForm
            size={gridSizeMdLg6}
            disabled={true}
            label={texto.tipo_contrato}
            defaultValue={
              formFormasPagosInstalacion.getValues().tipo_contrato || ""
            }
            shrink={!!formFormasPagosInstalacion.getValues().tipo_contrato}
          /> */}

          {formFormasPagosInstalacion.getValues().codigo_forma_pago ==
            PaymentMethodEnum.DEBITO && (
              <>
                <CustomAutocompleteArrString
                  size={gridSizeMdLg6}
                  label={texto.tipo_cuenta}
                  name="tipo_cuenta_bancaria"
                  options={
                    formFormasPagosInstalacion.getValues().entidad_financiera ==
                      EntidadFinancieraENUM.GUAYAQUIL
                      ? TIPO_CUENTA_BANCARIA_CHOICE
                      : TIPO_CUENTA_BANCARIA_CHOICE.filter(
                        (e) => e != TipoCuentaBancariaEnumChoice.AMIGA
                      ) || []
                  }
                  defaultValue={
                    formFormasPagosInstalacion.getValues().tipo_cuenta_bancaria
                  }
                  isLoadingData={false}
                  control={formFormasPagosInstalacion.control}
                  error={formFormasPagosInstalacion.formState.errors.tipo_cuenta_bancaria}
                  helperText={formFormasPagosInstalacion.formState.errors.tipo_cuenta_bancaria?.message}
                  onChangeValue={(e) => {
                    reset({
                      ...formPlanesPagos.getValues(),
                      tipo_cuenta_instalacion: e,
                    });
                  }}
                />

                {!isLoadingCooperativaInstalacion &&
                  dataCooperativaInstalacion?.length != 0 && (
                    <CustomAutocomplete<Cooperativa>
                      size={gridSizeMdLg6}
                      label={texto.cooperativa}
                      name="cooperativa"
                      // options
                      options={dataCooperativaInstalacion || []}
                      valueKey="nombre" // name is the fk
                      actualValueKey="codigo"
                      defaultValue={
                        formFormasPagosInstalacion.getValues().cooperativa || ""
                      }
                      isLoadingData={isLoadingCooperativaInstalacion}
                      // validation
                      control={formFormasPagosInstalacion.control}
                      error={formFormasPagosInstalacion.formState.errors.cooperativa}
                      helperText={formFormasPagosInstalacion.formState.errors.cooperativa?.message}
                      onChangeValue={(e) => {
                        reset({ ...formPlanesPagos.getValues(), cooperativa_instalacion: e });
                      }}
                    />
                  )}

                <CustomTextFieldNumberComponente
                  type={TiposTextFieldNumberEnum.TARJETA}
                  size={gridSizeMdLg12}
                  label={texto.numero_cuenta}
                  error={formFormasPagosInstalacion.formState.errors.numero_cuenta}
                  helperText={formFormasPagosInstalacion.formState.errors.numero_cuenta?.message}
                  control={formFormasPagosInstalacion.control}
                  name="numero_cuenta"
                  defaultValue={formFormasPagosInstalacion.getValues().numero_cuenta}
                  max={25}
                  onChangeValue={(e) => {
                    reset({ ...formPlanesPagos.getValues(), numero_cuenta_instalacion: e });
                  }}
                />
              </>
            )}

          {formFormasPagosInstalacion.getValues().codigo_forma_pago ==
            PaymentMethodEnum.TARJETA && (
              <>
                <CustomAutocomplete<EntidadesFinancieras>
                  size={gridSizeMdLg6}
                  label={texto.entidad_finciera}
                  name="entidad_financiera"
                  // options
                  options={dataEntidadFinancieroInstalacion?.data.data || []}
                  valueKey="nombre" // name is the fk
                  actualValueKey="codigo"
                  defaultValue={
                    formFormasPagosInstalacion.getValues().entidad_financiera || ""
                  }
                  isLoadingData={isLoadingEntidadFinancieroInstalacion}
                  // validation
                  control={formFormasPagosInstalacion.control}
                  error={formFormasPagosInstalacion.formState.errors.entidad_financiera}
                  helperText={formFormasPagosInstalacion.formState.errors.entidad_financiera?.message}
                  onChangeValue={(e) => {
                    reset({
                      ...formPlanesPagos.getValues(),
                      entidad_bancaria_instalacion: e,
                    });
                  }}
                />

                <SampleDatePicker
                  format="YYYY-MM"
                  views={["year", "month"]}
                  label="Fecha Caducidad"
                  name="tarjeta_fecha_caducidad"
                  minDate={dayjs(new Date())}
                  control={formFormasPagosInstalacion.control}
                  defaultValue={
                    formFormasPagosInstalacion.getValues().tarjeta_fecha_caducidad ??
                    ""
                  }
                  error={formFormasPagosInstalacion.formState.errors.tarjeta_fecha_caducidad}
                  helperText={formFormasPagosInstalacion.formState.errors.tarjeta_fecha_caducidad?.message}
                  size={gridSizeMdLg6}
                  onChangeValue={(e) => {
                    reset({
                      ...formPlanesPagos.getValues(),
                      fecha_caducidad_tarjeta_instalacion: e,
                    });
                  }}
                />

                <CustomTextFieldNumberComponente
                  type={TiposTextFieldNumberEnum.TARJETA}
                  startAdornment={
                    fnMostrarTipoTarjeta(tipoTarjetaInstalacion) ? (
                      <img
                        src={fnMostrarTipoTarjeta(tipoTarjetaInstalacion)}
                        alt="imge-tarjeta"
                        width={"50px"}
                      />
                    ) : null
                  }
                  size={gridSizeMdLg12}
                  label={texto.ingresar_num_tarjeta}
                  error={formFormasPagosInstalacion.formState.errors.numero_tarjeta}
                  helperText={formFormasPagosInstalacion.formState.errors.numero_tarjeta?.message}
                  control={formFormasPagosInstalacion.control}
                  name="numero_tarjeta"
                  defaultValue={
                    formFormasPagosInstalacion.getValues().numero_tarjeta ?? ""
                  }
                  max={24}
                  onChangeValue={(e) => {
                    reset({ ...formPlanesPagos.getValues(), numero_tarjeta_instalacion: e });
                  }}
                />
              </>
            )}
        </>
      </Grid>
      :<Grid item {...gridSizeMdLg12}>
        <Typography variant="h6">Pagos no aplican para eventos gratuitos y canjes.</Typography>
      </Grid>
      }




    </Grid>
  );
}
